package pwgs.ui.scenes.logoutscene

import kotlinx.browser.window


class LogoutControllerFe(props: LogoutSceneProps, scene: MLogoutScene) : ALogoutControllerFe(props, scene) {

    override fun createInitialModel() : LogoutSceneModel {
        return LogoutSceneModel()
    }

    override fun init() {
        launchOnDefaultControllerScope {
            var logoutUrl = window.location.protocol + "//" + window.location.hostname
            val port = window.location.port
            if (port == "8080") {
                logoutUrl += ":$port"
            }
            logoutUrl += "/index.jsp"
            val res = backend.logout(logoutUrl)
            window.location.href = res.logoutUrl!!
        }
    }


}

